module.exports = __webpack_public_path__ + "img/iq.55dfc84e.svg";